<template>
    <div class="col-12 col-lg-6 overflow-auto" style="height: 80vh;">
        <div class="d-flex ml-2">
          <template v-if="crew.active == 1 && !guest ">
            <h5 class="font-weight-bolder mr-auto">P & I Checkup Records</h5>
            <add-pandi-checkup :pandi="pandi"
                               v-if="isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff"
            ></add-pandi-checkup>
          </template>
        </div>

        <div class="overflow-auto" style="height: 75vh">

            <div v-for="(pandiCheckup, index) in pandiCheckups" :key="pandiCheckup.id">
                <hr class="my-1"/>
                <div class="d-flex" style="height: 3vh">
                    <label class="col-form-label font-weight-bold mr-auto"><u>Check Up Report {{ pandiCheckups.length - index }} :</u></label>
                    <button role="button" class="btn btn-warning btn-sm btn-xs font-weight-bold mr-2"
                            data-toggle="modal" data-target="#update-pandi-checkup"
                            @click="viewPandiCheckup = pandiCheckup"
                            v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest"
                    >
                        <i class="fas fa-edit"></i>
                        Edit
                    </button>

                    <button role="button" class="btn btn-outline-danger btn-sm btn-xs font-weight-bold"
                            v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest"
                            @click="confirmDeletePandiCheckup(pandiCheckup)"
                    >
                        <i class="fas fa-trash"></i>
                        Delete
                    </button>
                </div>
                <div class="d-flex m-2 align-items-center">
                  <div class="font-weight-bold mr-2" style="width: 10vh;">
                    Date :
                  </div>
                  <div>{{ pandiCheckup.checkup_date | moment('DD MMMM Y') }}</div>
                  <div
                      v-if="pandiCheckup.hasFile"
                      class="d-flex ml-auto align-items-center"
                  >
                    <div class="font-weight-bold mr-2">
                      Attachment :
                    </div>

                    <button
                      type="button"
                      class="btn btn-link p-0 mr-5"
                      title="View Checkup Report Attachment"
                      @click.stop="viewCheckupReportFile(index, pandiCheckup.id)"
                    >
                      <span class="fas fa-file-pdf text-danger"></span>
                    </button>
                  </div>
                </div>

                <div class="d-flex mx-2">
                    <label class="form-label font-weight-bold mr-2"
                           style="width: 10vh"
                    >Remarks:</label>
                    <p class="form-label text-justify">{{ pandiCheckup.remarks }}</p>
                </div>
            </div>
        </div>
        <edit-pandi-checkup :view-pandi-checkup="viewPandiCheckup"></edit-pandi-checkup>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";

import AddPandiCheckup from "./AddPandiCheckup";
import EditPandiCheckup from "./EditPandiCheckup";
import {FileService} from "@/services/FileService";

export default {
    name: "PandiCheckupIndex",

    mixins: [ vueAppMixin, formMixin, dataMixin, gateMixin ],

    props: {
        pandi: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    components: { AddPandiCheckup, EditPandiCheckup },

    data() {
        return {
            viewPandiCheckup: {}
        }
    },

    methods: {
        ...mapActions([
            'getCheckupReportFile',
            'deletePandiCheckup'
        ]),

        async viewCheckupReportFile(index, checkupReportId) {
            this.checkupReportFile = '';
            let params = {
                checkupReportId: checkupReportId
            };

            const checkupReportFile = await this.getCheckupReportFile(params);

            if(!checkupReportFile) {
              return
            }

            FileService.viewFile(checkupReportFile)
        },

        async confirmDeletePandiCheckup(pandiCheckup) {
            if(await this.confirmDeleteAlert()) {
                let params = {
                    id: pandiCheckup.id,
                    pandi_id: pandiCheckup.pandi_id
                };
                let deletedPandiCheckup = await this.deletePandiCheckup(params);
                if(deletedPandiCheckup !== false) {
                    if(!deletedPandiCheckup.errors) {
                        this.successAlert('P&I Checkup Successfully DELETED', 'DELETE');
                    }
                } else {
                    this.errorAlert('P&I Checkup Failed to DELETE', 'DELETE');
                }
            }
        },
    },

    computed: {
        ...mapGetters([
            'pandiCheckups'
        ])
    },

}
</script>

<style scoped>

</style>